export default "/images/icons8-india.png?ea21583268c007467f466b910de69a0d";